
import React, {useState, useRef, useEffect, Fragment} from 'react';
import { useQuery } from '@tanstack/react-query';
import { _FETCH } from '../../lib/patches';
import { clientRegistersQuery, registersOfTemplateQuery } from '../../lib/data';
import { useCreateReplace } from '../../hooks/mutations';
import PromiseQueue from 'p-queue'
import { addValueForDropdown, errorAlert, positionNumber, registerCollections, sortByLabel, successAlert } from '../../lib/utils';
import FieldDropdown from '../FieldDropdown';
import VisDiv from '../frontend_components/VisDiv';
import Loading from '../Loading';
import TextHighlight from '../frontend_components/TextHighlight';
import { TiDelete } from 'react-icons/ti';
import { useStateContext } from '../../context/StateContext';
import { useAuthContext } from '../../hooks/useAuthContext';


/**
 * Replaces all non-conformities in all registers with the same template with the selected new non-conformity
 * #databaseManagement
 * #registerManagement
 * 
 * @param {void}
 */
const RegistersManagement = ({client, clients, sites, registerTemplate, nonConformities}) => {

    const {apiUrl} = useStateContext()
    const fetchRoute = `${apiUrl}/calls/fetch-docs`
    const {user} = useAuthContext()

    const [clientSites, setClientSites] = useState()
    const [oldNonConformity, setOldNonConformity] = useState()
    const [newNonConformity, setNewNonConformity] = useState()
    const [viewNonConfInfo, setViewNonConfInfo] = useState(false)
    const [loadAllRegisters, setLoadAllRegisters] = useState(false)
    const [loading, setLoading] = useState(false);
    

    const sitesIds = clientSites?.map?.((site)=>{
        return (
            `"${site?._id}"`
        )
    })

    const {data: registersData, isLoading: registersLoading} = useQuery(['registers',{id:2}], ()=> _FETCH({route: fetchRoute, user, query: registersOfTemplateQuery(registerTemplate?._id)}),{
        enabled: !! registerTemplate,
        onError:(error)=>{console.log("registers data in template", error)},
      })
      const {data: allRegisters, isLoading: allRegistersLoading} = useQuery(['allRegisters',{id:3}], ()=> _FETCH({route: fetchRoute, user, query: '*[_type == "register"]'}),{
        enabled: loadAllRegisters,
        onError:(error)=>{console.log("nonConformities", error)},
      })

      const [registers, setRegisters] = useState()
      useEffect(() => {
        setRegisters(allRegisters ? allRegisters : registersData)
      }, [allRegisters, registersData]);

/*     const {data: registers, loading: registersDataLoading} = useQuery(['registers', sitesIds], ()=>_FETCH({route: fetchRoute, user, query: clientRegistersQuery(sitesIds)}),{
        enabled: !! sitesIds,
        onError:(error)=>{console.log("register data not loaded", error)},
    }) */

    useEffect(()=>{
        const filteredSites = !Array.isArray(sites) ? [] : sites?.filter?.((x)=>x?.client?._ref == client?._id)
        setClientSites(filteredSites)
        //console.log("FILTERED SITES", filteredSites)
    },[client])
    //console.log("Registers", registers)

    const {mutate: updateDatabase} = useCreateReplace({
        onError:(e)=>{
            console.log("REGISTER Not UPDATED", e)
            errorAlert("ERRORE, il documento non é stato aggiornato")

        }})

    const deleteDuplicateNonConformities = () => {
        if(registers) {
            for (let register of registers){
                const updateRegister = {
                    ...register, 
                    devices: register?.devices?.map?.((device)=>{
                        const nonConformities = device?.nonConformities ? device?.nonConformities : [] 
                        const nonConformitiesToDo = !Array.isArray(nonConformities) ? [] : nonConformities?.filter?.((x)=>x?.status == "DA FARE")
                        
                        const filterDuplicateNonConformities = !Array.isArray(nonConformitiesToDo) ? [] : nonConformitiesToDo?.filter?.((x, index)=>{
                            const findOriginalIndex = nonConformitiesToDo?.findIndex((y)=>y?.nonConformity?._ref == x?.nonConformity?._ref)
                            return findOriginalIndex == index
                        })


                        const nonConformitiesNOTToDo = !Array.isArray(nonConformities) ? [] : nonConformities?.filter?.((x)=>x?.status !== "DA FARE")
                        const allNonConformities = [...nonConformitiesNOTToDo, ...filterDuplicateNonConformities]

                        const updateDevice = {
                            ...device,
                            nonConformities: allNonConformities
                        }
                        return updateDevice
                        }
                    )
                }

                const nFilteredNonConformities = nRegisterNonConformities(updateRegister)?.nNonConformities
                const nOriginalNonConformities = nRegisterNonConformities(register)?.nNonConformities

                //const testRegisterId = "19aa1ed5-993e-451d-b073-12d5d97025b6"

                if(nOriginalNonConformities !== nFilteredNonConformities) {
                    console.log("register", register, "updatedRegister",updateRegister, "nFilteredNonConformities:", nFilteredNonConformities, "nOriginalNonConformities:", nOriginalNonConformities)
                    updateDatabase({doc: updateRegister})
                }
                 
            }
        }
        
    }

    const queue = new PromiseQueue({
        concurrency: 12,
        intervalCap: 15,
        interval: 700,
      })
      
    const templateNonConformities = !Array.isArray(nonConformities) ? [] : nonConformities?.filter?.((x)=>x?.registers?.some?.((y)=>y?._ref == registerTemplate?._id))?.sort(sortByLabel)
    const sortedNonConformities = nonConformities?.sort(sortByLabel)

    const replaceNonConformity = () => {
        if(!registers){
            console.log("REGISTERS NOT LOADED")
            return
        }
        if(!registerTemplate && !loadAllRegisters){
            console.log("SELECT REGISTER TEMPLATE")
            return
        }
        if(registers && (registerTemplate || loadAllRegisters)) {
           
            //console.log("TemplateNonConformities", templateNonConformities, registerTemplate)
            const registersOfTemplate = registers
            console.log("registersOfTemplate", registersOfTemplate)
            for (let register of registers){
                // FILTER REGISTER TEMPLATE
                const registerTemplateIdForFilter = registerTemplate?._id;
                if(registerTemplateIdForFilter ? register?.template?._ref == registerTemplateIdForFilter : true){
                    let found = false
                    //console.log("REGISTER", register)
                    const nonConformityToSubstituteId = oldNonConformity?._id;
                    const nonConformityToSubstituteWithId = newNonConformity?._id;
                    const updateRegister = {
                        ...register, 
                        devices: register?.devices?.map?.((device)=>{
                            const deviceNonConformities = device?.nonConformities ? device?.nonConformities : [] 
                            const findNonConfToSubstitute = !Array.isArray(deviceNonConformities) ? undefined : deviceNonConformities?.find?.((x)=>x?.nonConformity?._ref==nonConformityToSubstituteId)
                            const filteredNonConformities = !Array.isArray(deviceNonConformities) ? [] : deviceNonConformities?.filter?.((x)=>x?._id !== findNonConfToSubstitute?._id)
                            if(findNonConfToSubstitute) {
                                const updatedNonConformity = {...findNonConfToSubstitute, nonConformity: {...findNonConfToSubstitute?.nonConformity, _ref: nonConformityToSubstituteWithId}}
                                console.log("found:", device, findNonConfToSubstitute)
                                const updateDevice = {
                                    ...device,
                                    nonConformities:[...filteredNonConformities, updatedNonConformity]
                                }
                                console.log("found:", device, updateDevice)
                                found = true
                                return updateDevice
                            }
                            return device
                        })
                        
                    }
                    console.log(found)
                    if(found) {
                        queue.add(() => {
                            return updateDatabase({doc: updateRegister})
                            
                          })
                    }

                };
                    
            //console.log("REGISTER", register)
            }
        }
        
    }
    const registerCollection = registerCollections(registers, true)
    const allDeviceNonConformities = registerCollection?.nonConformities
    const allDevices = registerCollection?.devices

    const oldDeviceNonConformities = !Array.isArray(allDeviceNonConformities) ? [] : allDeviceNonConformities?.filter?.((x)=>x?.nonConformity?._ref == oldNonConformity?._id)

    const testFunction = () => {
       // console.log(registers?.filter?.((x)=>x?._createdAt?.includes("2023-12-27")))
       const regTest = !Array.isArray(registers) ? undefined : registers?.find?.((x)=>x?._id == "1cb33cd9-4b59-4e45-b53e-b4c45b27723d")
       const nonConf = !Array.isArray(regTest?.devices) ? undefined : regTest?.devices?.find?.((x)=>!Array.isArray(x?.nonConformities) ? undefined : x?.nonConformities?.find?.((x)=>x?.nonConformity?._ref == "reywrjGp1Dklgs7pZYr2Ht"))
        //console.log("ALL REGISTERS" , !Array.isArray(nonConf?.nonConformities) ? undefined : nonConf?.nonConformities?.find?.((x)=>x?.nonConformity?._ref == "reywrjGp1Dklgs7pZYr2Ht") ,  "queue")
        console.log("dhwkehdkuyh", {oldDeviceNonConformities} )
        
       //console.log("NON CONFORMITA' DA SOSTITUIRE", findRegistersWithTemplateDevice(registers, "4ed9b9b0-45b5-4638-9e32-d169cdc0e7c0"))
    }
   //deleteDuplicateNonConformities()
   //if(!client) return "SELEZIONA CLIENTE"
   if(allRegistersLoading && loadAllRegisters) {
    return <Loading/>
}
   if(!registerTemplate && (allRegisters?.length < 1 || !allRegisters)) {return (
    <div>
        <h3>SELEZIONA REGISTRO TEMPLATE O CARICA TUTTI I REGISTRI</h3>
         <VisDiv rules={[registers?.length<1 || !registers]}><button className={"pdf-button"} onClick={()=>{setLoadAllRegisters(true)}}>CARICA TUTTI I REGISTRI</button></VisDiv>        
    </div>
 
   )}
  return (
    <div>
        {/* <button onClick={replaceNonConformity}>DELETE DUPLICATE NON CONFORMITIES</button> */}
        <button onClick={testFunction}>test</button>
        <h3>NON CONFORMITA' DA SOSTITUIRE</h3>
            <FieldDropdown
                isSearchable="isSearchable"
                placeHolder={"NON CONFORMITA' SORGENTE"}
                options={addValueForDropdown(!registerTemplate ? sortedNonConformities : templateNonConformities)}
                onChange={(value) => setOldNonConformity(value)}
            />
         
        <VisDiv rules={[oldNonConformity]}>
            <VisDiv rules={[registersLoading && !loadAllRegisters]}><Loading/></VisDiv>
            <VisDiv rules={[registers?.length > 0]}>
                <VisDiv  style={{marginBottom:"15px"}} onClick={()=>{setViewNonConfInfo(!viewNonConfInfo)}}> 
                    NUMERO NON CONFORMITA' TROVATE: {oldDeviceNonConformities?.length} 
                </VisDiv> 
                <VisDiv rules={[loading]}>
                    <Loading/>
                </VisDiv>
                <VisDiv rules={[viewNonConfInfo, !loading]} style={{marginBottom:"15px", marginLeft:"15px"}}>
                    {oldDeviceNonConformities?.map?.((item, index)=>{
                        const nonConformity = !Array.isArray(nonConformities) ? undefined : nonConformities?.find?.((x)=>x?._id == item?.nonConformity?._ref)
                        const comma = (data) => data ? "," : ""
                
                        const site = !Array.isArray(sites) ? undefined : sites?.find?.((x)=>x?._id == item?.site?._ref)
                        const siteLabel = site?.label ? site?.label : ""
                        const client = !Array.isArray(clients) ? undefined : clients?.find?.((x)=>x?._id == site?.client?._ref)
                        const clientLabel = client?.label? client?.label : ""
                        const device = !Array.isArray(allDevices) ? undefined : allDevices?.find?.((x)=>item?.device?._ref == x?._id)
                        const deviceLabel = device?.label ? device?.label : ""
                        const register = !Array.isArray(registers) ? undefined : registers?.find?.((x)=> item?.register?._ref == x?._id)
                        const registerName = register?.name ? register.name : ""
                        const location = positionNumber(device)
                        const deleteLine = () => {
                            
                            const registerWithoutNonConf = {
                                ...register,
                                devices: !Array.isArray(register?.devices) ? [] : register?.devices?.map?.((dev)=>{
                                    if(dev?._id == device?._id) {
                                        const newArray = [...!Array.isArray(dev?.nonConformities) ? [] : dev?.nonConformities?.filter?.((x)=>x?._id !== item?._id)]
                                        const newDev = {...!Array.isArray(dev) ? {} : dev, nonConformities: newArray }
                                        console.log("NEW DEVICE WITHOUT NON CONF", newDev, "OLD DEVICE", dev)
                                        return newDev
                                        }
                                    return dev
                                })
                            }
                            console.log("DELETE LINE", register, "WITHOUT NON CONF", registerWithoutNonConf)
                        
                            updateDatabase({doc: registerWithoutNonConf},{
                                onSuccess:()=>{
                                    setRegisters([...!Array.isArray(registers) ? [] : registers?.filter?.((x)=>x?._id !== registerWithoutNonConf?._id), registerWithoutNonConf ])
                                },
                            }
                            
                            )

                            setRegisters()
                        }
                        //<a href={`../device/${device?._id}`} target={"_blank"} key={index}></a>
                        return (
                        <div  key={index} style={{padding:"5px"}}>
                            <div style={{display:"flex"}}>
                                <VisDiv style={{marginRight:"10px"}}>
                                    <button
                                        type="button"
                                        className="remove-item"
                                        onClick={() => deleteLine()}
                                        >
                                        <TiDelete />
                                    </button>
                                </VisDiv>
                                <VisDiv rules={[clientLabel]} style={{marginRight:"10px"}} >
                                    <TextHighlight highlight={"green"}>{clientLabel}</TextHighlight>
                                </VisDiv>
                                <VisDiv rules={[siteLabel]}  style={{marginRight:"10px"}} >
                                    <TextHighlight highlight={"blue"}>{siteLabel}</TextHighlight>
                                </VisDiv>
                                <VisDiv rules={[deviceLabel]} style={{marginRight:"10px"}}>
                                    <TextHighlight  highlight={"yellow"}>{deviceLabel}</TextHighlight>
                                </VisDiv>
                                <VisDiv rules={[deviceLabel]} style={{marginRight:"10px"}}>
                                    <TextHighlight  highlight={"amber"}>{`POSIZIONE ${location}`}</TextHighlight>
                                </VisDiv>
                            </div>
                        </div>
                        )
                    })}
                </VisDiv>
            </VisDiv>
            <h3>NUOVA NON CONFORMITA'</h3>
            <FieldDropdown
                    isSearchable="isSearchable"
                    placeHolder={"NUOVA NON CONFORMITA'"}
                    options={addValueForDropdown(!registerTemplate ? sortedNonConformities : templateNonConformities)}
                    onChange={(value) => setNewNonConformity(value)}
                />
        </VisDiv>
        <VisDiv rules={[newNonConformity && registers]}>
            <button onClick={replaceNonConformity}>SOSTITUISCI NON CONFORMITA'</button>
        </VisDiv>
    </div>
  )
}

export default RegistersManagement


export const nRegisterNonConformities = (register) => {
    const nNonConformities = {
        nDevices: register?.devices?.length,
        nNonConformities: register?.devices?.map?.((device)=>{
            const nonConformities = device?.nonConformities ? device?.nonConformities : []
            const nNonConf = nonConformities?.length
            return  nNonConf
        })?.reduce((partialSum, a) => partialSum + a, 0)
    }
    return nNonConformities
}